import React, { useState } from 'react';
import './DashboardLogin.css';

const DashboardLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.success) {
        onLogin(data.token, data.user);
      } else {
        setError(data.message || 'بيانات الدخول غير صحيحة');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('خطأ في الاتصال. يرجى التحقق من تشغيل الخادم.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-login-container">
      <div className="dashboard-login-box">
        <div className="dashboard-login-header">
          <div className="dashboard-logo">
            <h1>مراسلات</h1>
            <p>نظام إدارة المحتوى</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="dashboard-login-form">
          <div className="dashboard-form-group">
            <label>اسم المستخدم أو البريد الإلكتروني</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="أدخل اسم المستخدم أو البريد الإلكتروني"
            />
          </div>

          <div className="dashboard-form-group">
            <label>كلمة المرور</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="أدخل كلمة المرور"
            />
          </div>

          {error && <div className="dashboard-error-message">{error}</div>}

          <button type="submit" className="dashboard-btn-primary" disabled={loading}>
            {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
          </button>
        </form>

        <div className="dashboard-login-footer">
          <p>الافتراضي: admin / admin123</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardLogin;

